interface PlayButtonSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PlayButtonSVG = ({ color, style }: PlayButtonSVGProps) => (
  <svg
    style={style}
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="60"
      cy="60"
      r="56.3636"
      stroke="#D9D9D9"
      strokeWidth="7.27273"
    />
    <path
      d="M39.75 87.0001C39.1533 87.0001 38.581 86.7631 38.159 86.3411C37.7371 85.9191 37.5 85.3468 37.5 84.7501V35.2501C37.5001 34.8591 37.602 34.4749 37.7958 34.1353C37.9896 33.7957 38.2685 33.5125 38.6051 33.3136C38.9417 33.1146 39.3243 33.0068 39.7152 33.0008C40.1062 32.9947 40.4919 33.0906 40.8345 33.2791L85.8345 58.0291C86.1873 58.2233 86.4814 58.5087 86.6863 58.8554C86.8912 59.2021 86.9993 59.5974 86.9993 60.0001C86.9993 60.4028 86.8912 60.7981 86.6863 61.1448C86.4814 61.4915 86.1873 61.7769 85.8345 61.9711L40.8345 86.7211C40.5023 86.904 40.1292 87 39.75 87.0001ZM42 39.0526V80.9476L80.0812 60.0001L42 39.0526Z"
      fill={color}
    />
  </svg>
);

export default PlayButtonSVG;
